
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/user-plan",
      function () {
        return require("private-next-pages/profile/user-plan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/user-plan"])
      });
    }
  